import { render, staticRenderFns } from "./PublicWithdrawView.vue?vue&type=template&id=6621794e&scoped=true&"
import script from "./PublicWithdrawView.vue?vue&type=script&lang=js&"
export * from "./PublicWithdrawView.vue?vue&type=script&lang=js&"
import style0 from "./PublicWithdrawView.vue?vue&type=style&index=0&id=6621794e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621794e",
  null
  
)

export default component.exports